import { makeStyles } from '@fluentui/react-components';

export const useLogoStyles = makeStyles({
  container: {
    width: 'auto',
    height: '56px',
  },
});
